import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { PlanerTilGodkendelse } from '@store/models';

@Component({
    selector: 'app-planer-til-godk-ui',
    templateUrl: './planer-til-godk.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlanerTilGodkendelseComponent {

    @Input() planerTilGodkendelse: PlanerTilGodkendelse[];
    @Output() clickPlan = new EventEmitter<PlanerTilGodkendelse>();
    @Output() dismiss = new EventEmitter();

    onClickPlan(planer: PlanerTilGodkendelse) {
        this.clickPlan.emit(planer);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
